
<template>
    <div class="searchOuter">
        <div class="searchInner">
            
            <button v-on:click="SearchContent">
                <span>{{buttonName}}</span>
            </button>
            <input type="text" placeholder="请输入待搜索内容" v-model="content" v-on:keyup.enter="SearchContent" >

        </div>
    </div>
</template>

<script>
export default {
  // name: 'Empty',
  components: {},
  props: {
    // content: String,
    // soft: String,
    buttonName: {type:String, default:"搜索"}
  },
  data () {
    return {
      visible: true,
      msg: 'Welcome to Your Vue.js App',

    //   queryInfo: {key:"easyicon", len:10},
      content: "",
    }
  },

  mounted()
  {
    // this.soft = this.$route.params.soft;
  },
  created()
  {
    if ( typeof(this.$route.query.key) != "undefined" )
    {
      this.content = this.$route.query.key;
      if(this.content === "*") this.content = "";
      // console.log("query参数：" + JSON.stringify(this.query));
    }

  },

  methods: {
    
    // 内容搜索逻辑
    SearchContent(){
        // console.log("SearchContent已经调用！");
        this.$emit('Search', this.content);
    }
    // // string转为base64
    // stringToBase64(str) {
    //   return new Buffer.from(str).toString("base64");
    // },

    // // base64转字符串
    // base64ToString(b64) {
    //   return new Buffer.from(b64, "base64").toString();
    // },

  }

}
</script>

<style scoped>

.searchOuter
{
    height: 32px;
    width: 300px;
    text-align: right;
}

.searchInner{
    
    position: relative;
    height: 32px;
    width: 300px;
    max-width: 300px;
}

.searchInner button{
    float: right;

    height: 100%;
    width: 88px;
    display: inline-block;
    /* outline: 0;
    border: 0, none; */
    
    border: 1px solid #fc5531;
    border-radius: 0 16px 16px 0;
    font-size: 14px;
    cursor: pointer;
    transition:  all 0.2s ease-in;
    background-color: #fc5531;
    text-align:center;
    outline-style: none;
}

.searchInner button:hover{
    background-color: #eb360e;
}
.searchInner button:active{
    background-color: #fc5531;
}

.searchInner span{
    color: white;
}

.searchInner input{
    float: right;

    /* position: relative; */
    /* margin-top: 1px; */
    display: inline-block;
    font-size: 14px;
    width: calc(100% - 98px);
    height: calc(100% - 4px);
    background: #f5f6f7;
    border: 1px solid #e8e8ed;
    border-right: none;
    border-radius: 16px 0 0 16px;
    outline-style: none;

    text-align: center;
}
.searchInner input:focus{
    border-color:#fc5531;
    outline-color:#fc5531;
}


</style>


// WEBPACK FOOTER //
// src/components/control/SearchIteam.vue